import React from "react";
import PropTypes from "prop-types";
import HeaderTitle from "header/components/title";

const RegistrationHeaderTitle = () => <HeaderTitle title="Join crowdspring" />;

export default RegistrationHeaderTitle;
